// @flow

import { ACTION_TYPES } from './action';

export const BASE_SCHEMA_TYPES = { ...ACTION_TYPES, triggers: 'triggers' };
export const SERVICE_TYPES = {
  ...BASE_SCHEMA_TYPES,
  searchOrCreates: 'searchOrCreates',
  authentication: 'authentication',
};
export const SERVICE_ROUTES = {
  [SERVICE_TYPES.triggers]: SERVICE_TYPES.triggers,
  actions: 'actions',
};
